import { FETCH_HEADER_WARNING } from '../actions/types';

const INITIAL_STATE = {
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_HEADER_WARNING:
            return { ...state, msg:action.payload };
        default:
            return state;
    }
};
